/* eslint-disable ember/classic-decorator-hooks */
import * as RollOffStepResponse from '../../../step-response/roll-off';
import Circuit from './circuit';
import BigHugeCircuitGroup from './big-huge-circuit-group';
import BaseMain from '../../implementation-common/base-main';
import * as ReverseImplementation from './reverse-implementation';

export default class InductorBandPass extends BaseMain {
  bigHugeCircuitGroupModel;
  reverseImplementation;
  algorithm;

  init() {
    this.bigHugeCircuitGroupModel = BigHugeCircuitGroup;
    this.reverseImplementation = ReverseImplementation;
  }

  getStepValues(idealStep, circuit, timeAxis) {
    var k = (circuit.r3.value + circuit.r4.value) / circuit.r3.value;
    var result = RollOffStepResponse.getActualStepResponse(idealStep, circuit, timeAxis, k);
    return result;
  }

  createCircuit(stageFp, gain, stageQ, optimization, initialCapacitorValue) {
    var result = Circuit.create({
      algorithm: this.algorithm,
      stageFp: stageFp,
      gain: gain,
      stageQ: stageQ,
      optimization: optimization,
      initialCapacitorValue: initialCapacitorValue,
    });
    return result;
  }
}
